module.exports = __webpack_public_path__ + "img/4_4.a267abf7.jpg";